import { translate } from 'utils/translate';

export const EMPTY_INPUT_ERROR = () => translate('validationErrors.empty_input');
export const EMPTY_INPUTS_ERROR = () => translate('validationErrors.empty_inputs');
export const NO_SELECTED_DELIVERY_DAY_ERROR = () =>
   translate('validationErrors.no_selected_delivery_day');
export const NO_NUMERIC_VALUE_ERROR = () => translate('validationErrors.no_numeric_value');
export const NUMERIC_VALUE_LESS_OR_EQUAL_ZERO_ERROR = () =>
   translate('validationErrors.numeric_value_less_or_equal_zero');
export const NO_SELECTED_CLIENT_ERROR = () => translate('validationErrors.no_selected_client');
export const INVALID_ZIP_CODE_ERROR = () => translate('validationErrors.invalid_zip_code');
export const INVALID_EMAIL_ERROR = () => translate('validationErrors.invalid_email');
export const PASSWORD_MIN_LENGTH_ERROR = () => translate('validationErrors.password_min_length');
export const PALLETS_AMOUNT_LESS_OR_EQUAL_ZERO_ERROR = () =>
   translate('validationErrors.pallets_amount_less_or_equal_zero');
export const INVALID_PHONE_NUMBER_ERROR = () => translate('validationErrors.invalid_phone_number');
export const INVALID_NIP_ERROR = () => translate('validationErrors.invalid_nip');
export const PALLETS_AMOUNT_NO_INTEGER_ERROR = () =>
   translate('validationErrors.pallets_amount_no_integer');
export const NO_SELECTED_ORDERS_ERROR = () => translate('validationErrors.no_selected_orders');
export const SELECTED_TIME_HAS_ALREADY_PASSES_ERROR = () =>
   translate('validationErrors.selected_time_passed');
export const NO_SELECTED_DELIVERY_ERROR = () => translate('validationErrors.no_selected_delivery');
export const NO_SELECTED_STORAGE_ERROR = () => translate('validationErrors.no_selected_storage');
export const NO_UNIQUE_ADDRESS_NAME_ERROR = () =>
   translate('validationErrors.no_unique_address_name');
export const INVALID_DATE_ERROR = () => translate('validationErrors.invalid_date');
